import { render, staticRenderFns } from "./EditRuleItems.vue?vue&type=template&id=127597e4"
import script from "./EditRuleItems.vue?vue&type=script&lang=js"
export * from "./EditRuleItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports